import React, {Component} from 'react';
import PropTypes from "prop-types";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import StaticFunctions from "../../utils/StaticFunctions";

class TreeStructureOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        setCompany: PropTypes.func.isRequired,
    };

    static defaultProps = {
        selectedCompanyId: null,
        searchString: null,
        treeStructure: null,
    };

    constructor(props) {

        super(props);

        this.state = {
            openTreeFolders: [],
            searchString: (props.searchString) ? props.searchString : null
        };

        this.translate = this.props.baseData.translate;
        this.nextBoxKey = 0;

        this.selectCompany = this.selectCompany.bind(this);
        this.foldHandle = this.foldHandle.bind(this);
        this.setSearchFolderKeys = this.setSearchFolderKeys.bind(this);
        this.getNextBoxKey = this.getNextBoxKey.bind(this);
        this.renderBranchItem = this.renderBranchItem.bind(this);

    }

    componentWillMount() {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const state = {...this.state};

        //  Open Folders aus den userprops laden
        const openTreeFolders = (settings.openTreeFolders) ? JSON.parse(settings.openTreeFolders) : [];

        if (openTreeFolders.length > 0) state.openTreeFolders = openTreeFolders;

        this.setState(state);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.searchString !== this.props.searchString) {
            this.setState({
                searchString: (nextProps.searchString) ? nextProps.searchString : null
            }, this.setSearchFolderKeys);
        }

    }

    selectCompany(company) {

        if (this.props.setCompany) this.props.setCompany(company);

    }

    foldHandle(key) {

        if (!key) return null;

        let openTreeFolders = [].concat(this.state.openTreeFolders).concat(key);

        if (this.state.openTreeFolders.includes(key)) {
            openTreeFolders = this.state.openTreeFolders.filter((k) => k !== key);

            //this.selectCompany(null);
        }

        this.props.baseData.saveSettings('openTreeFolders', JSON.stringify(openTreeFolders));

        this.setState({
            openTreeFolders: openTreeFolders
        });

    }

    setSearchFolderKeys() {

        if (!this.props.treeStructure) return {mains: [], notAssigned: []};
        if (!this.state.searchString) return this.props.treeStructure;

        const rows = this.props.treeStructure.rows;
        const searchString = this.props.searchString;
        const foundCompanies = rows.filter((company) => company.name.toLowerCase().includes(searchString.toLowerCase()));
        const folderKeys = [];

        foundCompanies.forEach((company) => {
            if (company.id_parent === null) {
                folderKeys.push('company-notAssigned-' + company.id_root);
            } else {
                folderKeys.push('company-' + company.id_parent);
                folderKeys.push('company-' + company.id_root);
            }
        });

        this.setState({
            openTreeFolders: StaticFunctions.getUniqueArray(folderKeys)
        });

    }

    getNextBoxKey() {

        this.nextBoxKey++;

        return this.nextBoxKey;

    }

    getBranchLabel(item) {

        let label = (!item.id.includes('notAssigned') && item.name) ? item.name : this.translate('notAssigned');
        let childrenNote = ((item.children.length === 1) ? this.translate('client') : this.translate('clients'));

        if (!item.id.includes('notAssigned') && item.role === 'main') childrenNote = ((item.children.length === 1) ? this.translate('client') : this.translate('clients'));

        if (item.children.length > 0) label += ' (' + item.children.length + ' ' + childrenNote + ')';
        if (item.notAssigned.length > 0) label += ' (' + item.notAssigned[0].children.length + ' ' + this.translate('notAssigned') + ')';

        return label;

    }

    renderBranchItem(key, label, classes, foldClasses = null, item = null) {

        const foldButton = (foldClasses) ? <i className={foldClasses} onClick={() => this.foldHandle(key)}>&nbsp;</i> : null;
        const editButton = (item && !item.id.includes('notAssigned')) ? <i className="edit" onClick={() => this.selectCompany(item)} title={this.translate('edit')}>&nbsp;</i> : null;

        return (
            <div key={key} id={key} className={classes}>
                {foldButton}
                {editButton}
                <span>{label}</span>
            </div>
        );

    }

    renderBranch(root) {

        if (!root || root.length === 0) return null;

        const rootStructure = [];

        root.forEach((item) => {
            const key = 'company-' + item.id;
            const children = item.children.length;
            const notAssigned = item.notAssigned.length;

            //  TODO: Hide item if not searched?
            const isSearched = this.state.searchString && String(item.name.toLowerCase()).includes(this.state.searchString.toLowerCase()) ? 'searched' : '';
            const isActive = (item.id === this.props.selectedCompanyId) ? 'active' : '';
            const isFolded = ((children > 0 || notAssigned > 0) && !this.state.openTreeFolders.includes(key)) ? 'folded' : '';

            const label = this.getBranchLabel(item);
            const classes = ['treeBranch', isSearched, isActive].join(' ').trim();
            const foldClasses = ['foldHandle', isFolded].join(' ').trim();

            rootStructure.push(this.renderBranchItem(key, label, classes, foldClasses, item));

            if (this.state.openTreeFolders.includes(key)) {
                const childs = [];

                if (children > 0) childs.push(... item.children);
                if (notAssigned > 0) childs.push(... item.notAssigned);

                if (childs.length > 0) rootStructure.push(this.renderBranch(childs));
            }
        });

        if (rootStructure.length > 0) return <div key={'treeBranchBox-' + this.getNextBoxKey()} className="treeBranchBox">{rootStructure}</div>;

        return null;

    }

    render() {

        if (this.props.treeStructure === null) return <LoadingSplash color={'dark'}/>;

        const structure = this.props.treeStructure;
        const mains = [];

        if (structure.notAssigned.length > 0) mains.push(...structure.notAssigned);
        if (structure.mains.length > 0) mains.push(...structure.mains);

        return this.renderBranch(mains);

    }

}

export default TreeStructureOverviewContainer;